import { CIUDAD, CLIENTE, CLIENTE_DIRECCION_PROFORMA, logistica_GUIA, logistica_MANIFIESTO_PROFORMA } from "@pcgerente-node/pcg-comun/dist/DTOs";
import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { structureInfoState } from "../helpersRedux";
const initialState={
  guiasConsulta: new structureInfoState([] as logistica_GUIA[]), //nos trae las guias para presentar en la tabla de guias en: "/home/consulta/guia"
  manifiestosProformasConsulta: new structureInfoState([] as logistica_MANIFIESTO_PROFORMA[]), // nos trae las guias para presentar en la tabla de resumenes de guias en "/home/consulta/resumenGuias" 
  guiaConDetalles:  new structureInfoState(new logistica_GUIA()), //muestra los detalles de una guia pública en: "/home/consulta/detalles/:idGuia" 
  ciudadesConsulta: new structureInfoState([] as CIUDAD[]), //nos trae las ciudades para empatar el nombre con el idCiudad de guias o manifiestos. (Este estado es usado con las guiasConsultas y ManifiestosProformasConsultas)  
  destinatariosConsulta: new structureInfoState([] as CLIENTE[]), // nos trae solo el nombre y el id del cliente para enlazar los datos junto al manifiesto y la guia proforma  
  misDestinatariosConsultas: new structureInfoState([] as CLIENTE[]), //nos trae todos los clientes destinatarios en "misDestinatarios"
  agenciasDestinatarioSeleccionado: new structureInfoState([] as CLIENTE_DIRECCION_PROFORMA[]),
  BusquedaCliente: new structureInfoState([] as CLIENTE[]),
}

export const consultaSlice = createSlice({
  name: "consulta",
  initialState,
  reducers: {

    setCiudadesConsulta: (state, action: PayloadAction<structureInfoState<CIUDAD[]>>) =>{
      state.ciudadesConsulta = action.payload
    },
  
    setManifiestosProformasConsulta: (state, action: PayloadAction<structureInfoState<logistica_MANIFIESTO_PROFORMA[]>>) =>{
      state.manifiestosProformasConsulta = action.payload
    },
    
    setGuiasConsulta:(state, action: PayloadAction<structureInfoState<logistica_GUIA[]>>) =>{
      state.guiasConsulta = action.payload
    },

    //solo guarda la razón social y el id de los clientes
    setDestinatariosConsulta:(state, action: PayloadAction<structureInfoState<CLIENTE[]>>) =>{
      state.destinatariosConsulta = action.payload
    },

    setGuiaConDetalles: (state, action: PayloadAction<structureInfoState<logistica_GUIA>>) =>{
      state.guiaConDetalles = action.payload
    },

    setMisDestinatarioConsulta:(state, action: PayloadAction<structureInfoState<CLIENTE[]>>) =>{
      state.misDestinatariosConsultas = action.payload
    },

    setAgenciasDelDestinatario:(state, action: PayloadAction<structureInfoState<CLIENTE_DIRECCION_PROFORMA[]>>) =>{
      state.agenciasDestinatarioSeleccionado = action.payload
    },
    setBusquedaCliente:(state, action: PayloadAction<structureInfoState<CLIENTE[]>>) =>{
      state.BusquedaCliente = action.payload
    }
}
});


export const {
  setCiudadesConsulta,
  setGuiasConsulta,
  setManifiestosProformasConsulta,
  setDestinatariosConsulta,
  setGuiaConDetalles,
  setMisDestinatarioConsulta,
  setAgenciasDelDestinatario,
  setBusquedaCliente
} =consultaSlice.actions

export default consultaSlice.reducer